import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { LevelButton } from "./LevelButton";
import { Button } from "../../utils/Utils";
import { Background } from "../../Background";

export class LevelSelectionScene extends Phaser.Scene {

    public static readonly DELTA_BUTTONS = 130;

    public static currentInstance: LevelSelectionScene;
    
    constructor() {

        super("LevelSelectionScene");
        
        LevelSelectionScene.currentInstance = this;
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        const tmpBackground = this.add.graphics();
        tmpBackground.fillStyle(0xffffff);
        tmpBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        let background = new Background(this);
        this.add.existing(background);

        const backButton = new Button(this, 60, 60 * GameVars.scaleY, "texture_atlas_1", "btn_back", "btn_back_hover");
        backButton.scaleY = GameVars.scaleY;
        backButton.onUp(this.onClickBack, this);
        this.add.existing(backButton);

        const scaledItemsContainer = this.add.container(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);
        scaledItemsContainer.scaleY = GameVars.scaleY;

        let sceneTitleStr: string;

        switch (GameVars.difficulty) {

            case GameConstants.DIFFICULTY_EASY:
                sceneTitleStr = "easy";
                break;
            case GameConstants.DIFFICULTY_NORMAL:
                sceneTitleStr = "medium";
                break;
            case GameConstants.DIFFICULTY_HERO:
                sceneTitleStr = "hard";
                break;
            default:
        }

        const title = new Phaser.GameObjects.Image(this, 0, -300, "texture_atlas_1", "txt_" + sceneTitleStr);
        scaledItemsContainer.add(title);

        // los botones
        for (let i = 0; i < 3; i ++) {
            for (let j = 0; j < 4; j ++) {

                const level = i + 3 * j + 1;

                const levelButton = new LevelButton(this, level);
                levelButton.x = (i - 1) * LevelSelectionScene.DELTA_BUTTONS;
                levelButton.y = j * LevelSelectionScene.DELTA_BUTTONS - 100;
                scaledItemsContainer.add(levelButton);
            }
        }

        this.cameras.main.fadeIn(300, 255, 255, 255);
    }

    private onClickBack(): void {

        this.cameras.main.fadeOut(300, 255, 255, 255);

        this.cameras.main.once("camerafadeoutcomplete", function (): void {
            GameManager.enterDifficultySelectionScene();
        });
    }
}
